import { useState } from 'react'
import { Typography, IconButton } from '@mui/material'
import { Close } from '@mui/icons-material'
import { InfoCardIcon } from 'components/atoms/Icons'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { GridInfoStack } from 'components/atoms/InfoCard'
import { Trans, useTranslation } from 'react-i18next'
import timerIcon from 'assets/images/timer.svg'
import shieldLockIcon from 'assets/images/shieldLock.svg'
import assessmentIcon from 'assets/images/assessment.svg'
import fastStreamlinedIcon from 'assets/images/fastStreamlined.svg'
import leadershipDevelopmentIcon from 'assets/images/leadershipDevelopment.svg'
import { AssessmentHeadWrapper } from 'components/molecules/assessments/AssessmentMolecules'
import { ActionText } from 'components/atoms/Text'
import InfoDialog from '../notificationOverlay/InfoDialog'
import InCardStack from 'components/atoms/container/InCardStack'
import colors from 'styles/colors'
import RowStack from 'components/atoms/container/RowStack'

export const MoreOnConfidentiality = () => {
  const { t } = useTranslation()
  const [confidentialDialogOpen, setDisplayConfidentialInfo] = useState(false)

  const RenderConPoint = ({ i18nKey }) => (
    <Typography variant='body1' lineHeight={'140%'}>
      <Trans i18nKey={i18nKey} />
    </Typography>
  )

  return (
    <>
      <ActionText
        variant='body1Small'
        sx={{ alignItems: 'center', display: 'flex' }}
        onClick={() => setDisplayConfidentialInfo(true)}>
        <InfoOutlinedIcon sx={{ marginRight: 2 }} />
        {t('assessments.landingMoreConfidentiality')}
      </ActionText>

      <InfoDialog
        open={confidentialDialogOpen}
        onClose={() => setDisplayConfidentialInfo(false)}
        buttonText={t('rolePlay.okay')}
        sx={{ '& .MuiDialog-paper': { maxWidth: 720 } }}>
        <InCardStack spacing={6} sx={{ textAlign: 'start' }}>
          <RowStack justifyContent='space-between'>
            <Typography variant='h3' width={'100%'}>
              {t('confidentiality.takeConfidentialitySeriously')}
            </Typography>

            <IconButton
              sx={{
                color: colors.MidnightTeal400,
                padding: 0
              }}
              onClick={() => setDisplayConfidentialInfo(false)}>
              <Close />
            </IconButton>
          </RowStack>
          <RenderConPoint i18nKey='confidentiality.otherAssessment.part1' />
          <RenderConPoint i18nKey='confidentiality.otherAssessment.part2' />
          <RenderConPoint i18nKey='confidentiality.otherAssessment.part3' />
          <RenderConPoint i18nKey='confidentiality.otherAssessment.part4' />
          <RenderConPoint i18nKey='confidentiality.otherAssessment.part5' />
        </InCardStack>
      </InfoDialog>
    </>
  )
}

const AssessmentLanding = ({
  selfAssessment,
  goalName,
  questionCount,
  assessmentSenderName
}) => {
  const { t } = useTranslation()

  return selfAssessment ? (
    <AssessmentHeadWrapper
      title={t('assessments.getABaseline')}
      description={
        <Trans
          i18nKey='assessments.takeQuickSelfAssessment'
          values={{ goalName }}
        />
      }>
      <GridInfoStack
        title={t('assessments.landingQuestionTitle', {
          count: questionCount
        })}
        content={t('assessments.selfLandingQuestion', { count: questionCount })}
        icon={<InfoCardIcon src={timerIcon} size={56} />}
      />
      <GridInfoStack
        title={t('headers.aboutConfidentiality')}
        content={t('assessments.selfLandingConfidentiality')}
        icon={<InfoCardIcon src={shieldLockIcon} size={56} />}
      />
      <GridInfoStack
        title={t('assessments.selfLandingStarting')}
        content={t('assessments.selfLandingStartDescription')}
        icon={<InfoCardIcon src={assessmentIcon} size={56} />}
        size={{ sm: 12, md: 12, lg: 3.5 }}
      />
    </AssessmentHeadWrapper>
  ) : (
    <AssessmentHeadWrapper
      title={t('assessmentForOthers.welcomeToUserAssessment', {
        assessmentSenderName
      })}
      description={t('assessmentForOthers.feedbackOnBehavior', {
        assessmentSenderName
      })}>
      <GridInfoStack
        title={t('headers.aboutConfidentiality')}
        content={t('assessmentForOthers.toProtectPrivacy', {
          assessmentSenderName
        })}
        icon={<InfoCardIcon src={shieldLockIcon} size={56} />}>
        <MoreOnConfidentiality />
      </GridInfoStack>
      <GridInfoStack
        title={t('assessmentForOthers.fastStreamlined')}
        content={t('assessmentForOthers.assessmentConsistsOf', {
          count: questionCount
        })}
        icon={<InfoCardIcon src={fastStreamlinedIcon} size={56} />}
      />
      <GridInfoStack
        title={t('assessmentForOthers.leadershipDevelopment')}
        content={t('assessmentForOthers.diversePerspectives', {
          assessmentSenderName
        })}
        icon={<InfoCardIcon src={leadershipDevelopmentIcon} size={56} />}
        size={{ sm: 12, md: 12, lg: 3.5 }}
      />
    </AssessmentHeadWrapper>
  )
}

export default AssessmentLanding
